import React, {useMemo} from 'react';
import SelectMultiSearch from "@ui/select/selectMultiSearch/SelectMultiSearch";
import {useTranslation} from 'react-i18next';

interface IProps {
    groups: string[]
    value: string[],
    onChange: (value: string[]) => void,
    width?: string | number
}

const SelectGroupNameByDeviceActivity = ({
                                             value,
                                             onChange,
                                             groups,
                                             width,
                                         }: IProps) => {

    const {t} = useTranslation()

    const dataSelect = useMemo(() => {
        if (!groups?.length) {
            return []
        }
        return groups.map((it) => {
            return {
                value: it,
                label: it
            }
        })
    }, [groups])
    return (
        <SelectMultiSearch
            label={t('base.groups')}
            onChange={onChange}
            value={value}
            data={dataSelect}
            width={width}
        />
    );
};

export default SelectGroupNameByDeviceActivity;